<div class="card-box cursor-pointer" [routerLink]="enableRouter ? link : null" >
    <div class="d-flex justify-content-between">
        <div>
            <img width="42" [src]="icon1" alt="">
        </div>
        <div>
            <img *ngIf="isFree" width="53" [src]="icon2" alt="">
        </div>
    </div>
    <div>
        <h3 class="card-heading">{{ title }}</h3>
        <p class="card-para">{{ description }}</p>
    </div>
    <div style="margin-top: 12px;">
        <img [routerLink]="link" width="25" [src]="icon3" class="cursor-pointer" alt="">
    </div>
</div>
<p class="planes">{{planes}}</p>
